// extracted by mini-css-extract-plugin
export default {"chartToggles":"ug7XB_AhjRw1VSCLvQRT"};